import { render, staticRenderFns } from "./MessageForwarder.vue?vue&type=template&id=2b3ce24a"
import script from "./MessageForwarder.vue?vue&type=script&lang=js"
export * from "./MessageForwarder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports